import {Component, ChangeDetectionStrategy, Input} from '@angular/core';
import {Dialog} from '@vendure/admin-ui/core';

@Component({
  selector: 'app-oversize-images-dialog',
  templateUrl: './oversize-images-dialog.component.html',
  styleUrls: ['./oversize-images-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OversizeImagesDialogComponent implements Dialog {
  @Input() files: File[] = [];

  resolveWith: (result?: void) => void;

  constructor() {}

  /**
   * 下载所有超过大小的图片
   */
  downloadAll() {
    this.files.forEach((file, index) => {
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      // 添加小延迟避免浏览器阻止多个下载
      if (index < this.files.length - 1) {
        setTimeout(() => {}, 100);
      }
    });
  }

  /**
   * 下载单个文件
   */
  downloadFile(file: File) {
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  /**
   * 格式化文件大小
   */
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  /**
   * 关闭对话框
   */
  close() {
    this.resolveWith();
  }
}
